import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { MessageIcon, NakedButton, Text, EmailIcon } from '@frontend/design-system';

const styles = {
  mfaButton: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    border: 1px solid ${theme.colors.neutral20};
    border-radius: ${theme.borderRadius.medium};
    padding: ${theme.spacing(2)};
    width: 100%;
    margin-top: ${theme.spacing(2)};

    &:hover {
      background-color: ${theme.colors.neutral10};
    }
  `,
  icon: css`
    text-align: center;
    margin-bottom: ${theme.spacing(1)};
  `,
};

type AddMfaMethodButtonProps = React.ComponentProps<typeof NakedButton> & {
  label?: string;
  icon: 'message' | 'email';
};

export function AddMfaMethodButton({ icon, label, ...rest }: AddMfaMethodButtonProps) {
  return (
    <NakedButton css={styles.mfaButton} {...rest}>
      {icon === 'email' ? <EmailIcon css={styles.icon} /> : <MessageIcon css={styles.icon} />}
      <Text weight='bold'>{label}</Text>
    </NakedButton>
  );
}
